export const formatDate = (date: Date | string) => {
  // Check if the date is a string in DateOnly format (YYYY-MM-DD)
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const dateParts = date.split('-');
    console.log("IN THE DATE")
    const formattedDate = new Date(
        parseInt(dateParts[0]), // Year
        parseInt(dateParts[1]) - 1, // Month (0-based)
        parseInt(dateParts[2]) // Day
    );

    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }).format(formattedDate);
  }

  // Convert to Date object if not already
  const localDate = new Date(date);

  if (isNaN(localDate.getTime())) {
    return 'Invalid Date'; // Handle invalid date inputs
  }

  if (isToday(localDate)) {
    // Format time if date is today
    const shortTime = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }).format(localDate);

    return `Today at ${shortTime}`;
  } else {
    // Format full date in local timezone if not today
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }).format(localDate);
  }
};

export const formatDateTime = (date: Date) => {
  const shortDate = new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).format(date)

  return `${shortDate}`
}

export const formatTimeRange = (startTime: Date, endTime: Date): string => {
  const formatOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true, // This ensures AM/PM formatting
  };

  const startFormatted = new Intl.DateTimeFormat('en-US', formatOptions).format(startTime);
  const endFormatted = new Intl.DateTimeFormat('en-US', formatOptions).format(endTime);

  return `${startFormatted} - ${endFormatted}`;
};

export const formatDateShort = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',  // Mon, Tue, etc.
    day: 'numeric',    // 1, 2, etc.
    month: 'short',    // Jan, Feb, etc.
    year: 'numeric'    // 2024
  }).format(date);
};
export const formatTime = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', {
    timeStyle: 'short',
    timeZone: 'UTC'
  }).format(date)

}

const isToday = (date: Date) => {
  const today = new Date()

  return today.toDateString() === date.toDateString()
}

export const getFirstDayWeek = () => {
  const curr = new Date()
  const firstDate = new Date(curr.setDate(curr.getDate() - curr.getDay()))
  const formatString = firstDate.toISOString().substring(0, 10)
  return { formatDate, formatString }
}

export const getFormattedTodayDate = (daysToAdd = 0) => {
  const curr = new Date();
  curr.setDate(curr.getDate() + daysToAdd); // Add days to the current date
  const formatString = curr.toISOString().substring(0, 10);
  return { curr, formatString };
};

export const getLastDayWeek = () => {
  const curr = new Date()
  const lastDate = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6))
  const formatString = lastDate.toISOString().substring(0, 10)
  return { formatDate, formatString }
}

export const formatUSDate = (date: Date) => {
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(date)

  return formattedDate
}

export const formatUSDateTime = (date: Date) => {
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric'
  }).format(date)

  return formattedDate
}
